import styled from "@emotion/styled";

export const AccountFormWrapper = styled.div`
  position: relative;
`;
